module.exports = __webpack_public_path__ + "static/media/date-01.21f78364.svg";